import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { confirmInsuranceActivation } from '../../../thunks/activateInsurance/confirmInsuranceActivation';

interface IInsuranceState {
  isLoading: boolean;
  error: string | null;
}

const initialState: IInsuranceState = {
  isLoading: false,
  error: null,
};

const insuranceSlice = createSlice({
  name: 'insurance',
  initialState,
  reducers: {
    setInsuranceLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setInsuranceError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(confirmInsuranceActivation.pending, state => {
      state.error = null;
      state.isLoading = true;
    });
    builder.addCase(confirmInsuranceActivation.fulfilled, state => {
      state.isLoading = false;
    });
    builder.addCase(confirmInsuranceActivation.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload || 'Неизвестная ошибка';
    });
  },
});

export const { setInsuranceLoading, setInsuranceError } = insuranceSlice.actions;
export const insuranceReducer = insuranceSlice.reducer;
